export default __webpack_public_path__ + "static/media/grafico_02.5ced3124.png";